import React, {Component} from 'react';
import axios from 'axios';
import {Card} from "react-bootstrap";
import "./home_page_mobile_card7.scss";
import LuissButton from "./home_page_mobile_button/home_page_mobile_button";
import {Translation} from "react-i18next";

class HomePageMobileCard7 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            touched: false,
            fourElements: null
        };
    }

    componentDidMount() {
        axios.get(this.props.__data[0])
            .then((res) => {
                    this.setState({fourElements: res.data.cards})
                }
            ).catch(error => console.log('### Failed to load secondary data - error: ' + error))
    }

    render() {
        let cardBackground = {
            backgroundColor: "white"
        };

        if (this.state.fourElements === null) {
                return null;
        }
        if (this.state.fourElements.length === 0 ) {
            return null;
    }

        return (
            <Card className={"home-page-mobile-card7 " + (this.state.touched ? "touched" : "")}
                  style={cardBackground} onTouchStart={() => this.setState({touched: true})}
                  onTouchEnd={() => this.setState({touched: false})}>
                <Card.Body>
                    <Card.Title className="text subtitle not-selectable">{this.props.title}</Card.Title>
                    <div className="options">{this.state.fourElements.map((el, index) => {
                        if (index <= 3) {
                            return (
                                <div key={index} className="item">
                                    { el.image ? <div className="img-container">
                                        <img className="img" src={el.image} alt={'Luiss.it'}/>
                                    </div> : null }
                                    <div className={index === 3 ?  el.image ? 'text-button-item-no-border' : 'text-button-item-no-border-bigger' : el.image ? 'text-button-item' : 'text-button-item-bigger'}>
                                        <div>
                                            <div className="insideTitle">{el.title}</div>
                                            {el.subtitle ? <div className="insideSubtitle">{el.subtitle}</div> : null}
                                        </div>
                                        <div className="mobButton">
                                            {el.url &&
                                            <Translation>
                                                {(t) =>
                                                    <LuissButton url={el.url}>{el.link_title}</LuissButton>
                                                }
                                            </Translation>
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        } else {
                            return null;
                        }
                    })}
                    </div>
                </Card.Body>

            </Card>
        );
    }
}

export default HomePageMobileCard7;
